
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2023
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'createDashboardTitle': 'Dashboard erstellen',
	'dashboard': 'Dashboard',
	'dashboardTemplate': 'Dashboardvorlage',
	'createAV': 'Erstellen',
	'createAvEditNameLabel': '1. Namen für die Ansicht festlegen',
	'createAvSelectTemplateLabel': '2. Vorlage auswählen',
	'tabLayoutLabel': 'Vorlage mit Registerkarten',
	'infographicsLayoutLabel': 'Vorlage für Infografik',
	'singlePageLayoutLabel': 'Einseitige Vorlage',
	'customLayoutLabel': 'Benutzerdefinierte Vorlage',
	'freeformTemplate': 'Freies Format',
	'freeformTemplateDesc': 'Visualisierungen mit dem Layout \'Freies Format\' werden exakt mit der von Ihnen festgelegten Größe und Position in der Ansicht angezeigt, unabhängig von der Anzeigengröße. Bei den anderen Layouts werden Größe und Position der Visualisierungen an die Anzeige angepasst.',
	'NoTemplate': 'Freies Format',
	'Template1': 'Leer',
	'Template2': 'Titel 1 mal 2',
	'Template3': '2 über 1',
	'Template4': '4 über 1',
	'Template5': 'Fußzeile 1 mal 2',
	'Template6': '3 neben 1 über 1',
	'Template7': '4 neben 3 über 1',
	'Template8': '2 über 3 mal 2',
	'Template9': '2 mal 2',
	'Template10': '1 mal 2 neben 2 mal 2 über 1',
	'Template11': '3 mal 1 über 1 mal 2',
	'Template12': '2 über 1 neben 1 mal 2',
	'Template13': '1 neben 1 mal 2 neben 1 mal 4',
	'Template22': '1 über 2 mal 2',
	'Template14': '1 neben 1',
	'Template15': '1 über 1 neben 1',
	'Template16': '1 neben 1 über 1',
	'Template17': '1 über 1 neben 1 über 1',
	'Template18': '1 über 1 neben 1',
	'Template19': '1 über 2 neben 1',
	'Template20': '1 über 2 mal 1',
	'Template21': '1 über 1 über 2 mal 1',
	'Template23': 'Leer mit Ablegebereich',
	'Infographics1': 'Leer',
	'Infographics2': '4 Zeilen',
	'Infographics3': '4 Zeilen mit Überschriften',
	'Infographics4': '2 mal 4',
	'Infographics5': 'Große obere Anzeige mit 2 mal 2',
	'Infographics6': '2 mal 4 mit vertikalem Zwischenraum',
	'Infographics7': '2 mal 4 gestaffelt',
	'Infographics8': 'Tennisplatz',
	'Infographics9': '3 mal 4',
	'Infographics10': '4 mal 8',
	'createAvDashboardLabel': 'Layout',
	'dashboard_template_save_success': 'Die Dashboardvorlage wurde gespeichert.',
	'dashboard_template_prefix': 'Vorlage: "%{name}"',
	'dashboard_template_filters_removed': 'Filter im Erstellungsbereich wurden entfernt.',
	'createAvTabLabel': 'Registerkarten',
	'createAvInfographicsLabel': 'Infografik',
	'createAvSinglepageLabel': 'Einzelne Seite',
	'createAvCustomLabel': 'Benutzerdefiniert',
	'loadMoreLabel': 'Weitere laden...',
	'backLabel': 'Zurück',
	'addSourceLabel': 'Quelle hinzufügen',
	'pinLabel': 'Pin',
	'errorLoadingDataSetMetaData': 'Beim Lesen der Metadaten ist ein Fehler aufgetreten',
	'errorLoadingDataSets': 'Beim Laden der Liste mit Datasets ist ein Fehler aufgetreten',
	'errorLoadingDataSet': 'Das Laden der Metadaten für das Dataset "%{datasetName}" wurde nicht ausgeführt. Wenden Sie sich an den zuständigen Administrator, um Details zu erhalten.',
	'okButton': 'OK',
	'createButton': 'Erstellen',
	'cancelButton': 'Abbrechen',
	'copyButton': 'Kopieren',
	'selectTemplateLabel': 'Vorlage auswählen',
	'createBoardTitle': 'Dashboard erstellen',
	'createBoardSubtitle': 'Vorlage für das Dashboard auswählen',
	'noSourcesSelectedLabel': 'Keine Quellen ausgewählt',
	'find_label': 'Suchen',
	'noDashboardFound': 'Das Dashboard kann nicht abgerufen werden. Sie ist entweder nicht mehr vorhanden oder Sie verfügen nicht über ausreichende Berechtigungen für die Anzeige.',
	'errorLabel': 'Fehler',
	'defaultName': 'Neues Dashboard',
	'noDashboardCapability': 'Sie verfügen nicht über die Funktion zum Ausführen der Dashboardanwendung.',
	'noCapabilityForCreateDashboard': 'Sie verfügen nicht über die Funktionalität, die zum Erstellen eines Dashboards für die ausgewählten Assets erforderlich ist',
	'noCapabilityForEdit': 'Sie haben nicht die Möglichkeit, dieses Dashboard zu bearbeiten',
	'noCapabilityForSave': 'Sie haben nicht die Möglichkeit, dieses Dashboard zu speichern',
	'noCapabilityForPaste': 'In dieser Ansicht haben Sie keine Möglichkeit, kopierte Widgets einzufügen',
	'noCapabilityForPin': 'Sie haben nicht die Möglichkeit, diesen Pin hinzuzufügen',
	'noCapabilityForLaunchInExplore': 'Sie haben keine Möglichkeit, kopierte Widgets in einer Exploration zu starten',
	'noDashboardPermission': 'Sie verfügen nicht über ausreichende Berechtigungen zum Anzeigen dieses Dashboards.',
	'sourceNotFound': 'Die Visualisierung kann nicht geladen werden, da die zugehörige Quelle "%{sourceName}" nicht verfügbar ist.',
	'cmDuplicateName': 'Ein Element mit diesem Namen ist bereits vorhanden. Verwenden Sie einen anderen Namen.',
	'cmEmptySelection': 'Das Dashboard wurde gelöscht. Speichern Sie die Daten als neues Dashboard.',
	'propTheme_v1': 'Visuelles Motiv',
	'propTheme': 'Motiv',
	'legacyThemeLabel': 'Vorgängerdiagramm',
	'carbonGrey10Label': 'Carbon X (hell)',
	'carbonGrey100Label': 'Carbon X (dunkel)',
	'titleTextLabel': 'Titel',
	'titleSmallTextLabel': 'Titel - klein',
	'subtitleTextLabel': 'Untertitel',
	'bodyTextLabel': 'Hauptteil',
	'bodySmallTextLabel': 'Hauptteil - klein',
	'captionTextLabel': 'Titelzeile',
	'quoteTextLabel': 'Zitat',
	'quoteSmallTextLabel': 'Zitat - klein',
	'responsiveTextLabel': 'Größe automatisch anpassen',
	'mediaWidgetLabel': 'Medien',
	'webpageWidgetLabel': 'Webseite',
	'imageWidgetLabel': 'Bild',
	'textWidgetLabel': 'Text',
	'notebookWidgetLabel': 'Notebook',
	'multipurposeWidgetLabel': 'Verschiedene Verwendungsmöglichkeiten',
	'textPlaceHolder': 'Zum Bearbeiten von Text klicken',
	'titlePlaceHolder': 'Zum Bearbeiten des Titels klicken',
	'toggleEditModeLabel': 'Zur Bearbeitung wechseln',
	'togglePreviewModeLabel': 'Zur Vorschau wechseln',
	'editDashboardCoachMarkTitle': 'Dashboard bearbeiten',
	'editDashboardCoachMarkContents': 'Klicken Sie zum Bearbeiten dieses Dashboards auf das Stiftsymbol.',
	'addDataCoachMarkTitle': 'Daten hinzufügen',
	'addDataDashboardCoachMarkContents': 'Ziehen Sie Daten aus dem Datenfenster in das Dashboard und legen Sie sie ab.',
	'pageSelectWarning': 'Registerkarte auswählen.',
	'screenshot_label': 'Dashboard %{title}',
	'screenshot_label_tab': 'Registerkarte %{tabName} des Dashboards %{title}',
	'dataAssetPropertiesLabel': 'Visualisierungseigenschaften',
	'modelFilter': 'Filtern',
	'invertSelectionToolTip': 'Filterauswahl umkehren',
	'clearFilterValueToolTip': 'Filterwerte löschen',
	'invertFilterSelection': 'Auswahl umkehren',
	'clearTextFilterValue': 'Aufheben',
	'filterConditionLabel': 'Filterbedingung',
	'applyFilter': 'Filter anwenden',
	'itemCountText': '%{itemCount} Element(e) ausgewählt',
	'itemExcludeCountText': '%{itemCount} Element(e) ausgeschlossen',
	'moreMembers': 'Weitere anzeigen...',
	'searchHierarchyMembers': 'Mithilfe der Suchfunktion nach Mitgliedern suchen...',
	'propHideEmpty': 'Leere Kategorien ausblenden',
	'propColorOrder': 'Farbreihenfolge',
	'propElementColor': 'Farbe des Visualisierungselements',
	'propLineColor': 'Linienfarbe',
	'propLineAndSymbolColor': 'Linien- und Symbolfarbe',
	'propColumnColor': 'Säulenfarbe',
	'propBarColor': 'Balkenfarbe',
	'propWordColor': 'Wortfarbe',
	'propAreaColor': 'Flächenfarbe',
	'propRadialbarColor': 'Farbe für radiale Säule',
	'propColorPalettes': 'Farbpaletten',
	'propDashboardColorPalette': 'Aktuelle Dashboardpalette',
	'propNewDashboardPaletteLabel': 'Benutzerdefinierte Dashboardpalette erstellen',
	'propDashboardChangePaletteLink': 'Dashboardpalette ändern',
	'propHideLeafNode': 'Beschriftungen für Blattelemente ausblenden',
	'propOpacity_v1': 'Opazität des Widgets',
	'propOpacity': 'Opazität des Widgets (%)',
	'propOpacityDescription': 'Ändern Sie die Darstellung des Objekts auf mehr oder weniger undurchsichtig. Geben Sie einen Wert zwischen 0 und 100 ein',
	'addATab': 'Neue Registerkarte hinzufügen',
	'propFredIsRed': 'Farbkonsistenz',
	'areaChartCaption': 'Flächendiagramm',
	'areaChartDataSlot_categoriesLabel': 'Achsenbeschriftung',
	'areaChartDataSlot_valuesLabel': 'Wert',
	'areaChartProp_colorPaletteLabel': 'Farbpaletten',
	'areaChartProp_lineColorLabel': 'Flächenfarbe',
	'areaChartProp_interpolationLabel': 'Geglättete Linien',
	'areaChartProp_interpolationDescription': 'Verbindungslinien zwischen den Datenpunkten sind gebogen.',
	'areaChartProp_hideGridLinesLabel': 'Rasterlinien ausblenden',
	'areaChartProp_hideGridLinesDescription': 'Rasterlinien ausblenden',
	'areaChartProp_hideAxisTitleLabelsLabel': 'Achsentitelbeschriftungen ausblenden',
	'areaChartProp_hideAxisTitleLabelsDescription': 'Titel für die Achsen ausblenden.',
	'areaChartProp_maintainAxisScalesLabel': 'Achsenskala beibehalten',
	'areaChartProp_maintainAxisScalesDescription': 'Mindest- und Maximalwerte stets auf den Achsen anzeigen.',
	'areaChartProp_suppressZerosLabel': 'Leere Kategorien ausblenden',
	'areaChartProp_suppressZerosDescription': 'Kategorien ohne zugehörige Werte ausblenden.',
	'barChartCaption': 'Balkendiagramm',
	'barChartDataSlot_categoriesLabel': 'Achsenbeschriftung',
	'barChartDataSlot_valuesLabel': 'Wert',
	'barChartProp_colorPaletteLabel': 'Farbpaletten',
	'barChartProp_elementColorLabel': 'Balkenfarbe',
	'barChartProp_hideGridLinesLabel': 'Rasterlinien ausblenden',
	'barChartProp_hideGridLinesDescription': 'Rasterlinien ausblenden',
	'barChartProp_hideAxisTitleLabelsLabel': 'Achsentitelbeschriftungen ausblenden',
	'barChartProp_hideAxisTitleLabelsDescription': 'Titel für die Achsen ausblenden.',
	'barChartProp_maintainAxisScalesLabel': 'Achsenskala beibehalten',
	'barChartProp_maintainAxisScalesDescription': 'Mindest- und Maximalwerte stets auf den Achsen anzeigen.',
	'barChartProp_suppressZerosLabel': 'Leere Kategorien ausblenden',
	'barChartProp_suppressZerosDescription': 'Kategorien ohne zugehörige Werte ausblenden.',
	'columnChartCaption': 'Säulendiagramm',
	'columnChartDataSlot_categoriesLabel': 'Achsenbeschriftung',
	'columnChartDataSlot_valuesLabel': 'Wert',
	'columnChartProp_colorPaletteLabel': 'Farbpaletten',
	'columnChartProp_elementColorLabel': 'Säulenfarbe',
	'columnChartProp_hideGridLinesLabel': 'Rasterlinien ausblenden',
	'columnChartProp_hideGridLinesDescription': 'Rasterlinien ausblenden',
	'columnChartProp_hideAxisTitleLabelsLabel': 'Achsentitelbeschriftungen ausblenden',
	'columnChartProp_hideAxisTitleLabelsDescription': 'Titel für die Achsen ausblenden.',
	'columnChartProp_maintainAxisScalesLabel': 'Achsenskala beibehalten',
	'columnChartProp_maintainAxisScalesDescription': 'Mindest- und Maximalwerte stets auf den Achsen anzeigen.',
	'columnChartProp_suppressZerosLabel': 'Leere Kategorien ausblenden',
	'columnChartProp_suppressZerosDescription': 'Kategorien ohne zugehörige Werte ausblenden.',
	'bubbleChartCaption': 'Blasendiagramm',
	'bubbleChartDataSlot_xAxisLabel': 'Horizontale Achse',
	'bubbleChartDataSlot_yAxisLabel': 'Vertikale Achse',
	'bubbleChartDataSlot_sizeLabel': 'Größe nach',
	'bubbleChartDataSlot_colorLabel': 'Farbe nach',
	'bubbleChartProp_colorPaletteLabel': 'Farbpaletten',
	'bubbleChartProp_hideGridLinesLabel': 'Rasterlinien ausblenden',
	'bubbleChartProp_hideGridLinesDescription': 'Rasterlinien ausblenden',
	'bubbleChartProp_hideAxisTitleLabelsLabel': 'Achsentitelbeschriftungen ausblenden',
	'bubbleChartProp_hideAxisTitleLabelsDescription': 'Titel für die Achsen ausblenden.',
	'bubbleChartProp_maintainAxisScalesLabel': 'Achsenskala beibehalten',
	'bubbleChartProp_maintainAxisScalesDescription': 'Mindest- und Maximalwerte stets auf den Achsen anzeigen.',
	'bubbleChartProp_hideLegendLabel': 'Legende ausblenden',
	'bubbleChartProp_hideLegendDescription': 'Legende ausblenden.',
	'bubbleChartProp_legendPositionLabel': 'Position der Legende',
	'lineChartCaption': 'Liniendiagramm',
	'lineChartDataSlot_categoriesLabel': 'Achsenbeschriftung',
	'lineChartDataSlot_valuesLabel': 'Wert',
	'lineChartProp_colorPaletteLabel': 'Farbpaletten',
	'lineChartProp_lineColorLabel': 'Linien- und Symbolfarbe',
	'lineChartProp_symbolShapeLabel': 'Symbolform',
	'lineChartProp_hideSymbolsLabel': 'Symbole ausblenden',
	'lineChartProp_hideSymbolsDescription': 'Symbole ausblenden',
	'lineChartProp_hideDataLinesLabel': 'Linie(n) ausblenden',
	'lineChartProp_hideDataLinesDescription': 'Linie(n) ausblenden',
	'lineChartProp_interpolationLabel': 'Geglättete Linien',
	'lineChartProp_interpolationDescription': 'Verbindungslinien zwischen den Datenpunkten sind gebogen.',
	'lineChartProp_hideGridLinesLabel': 'Rasterlinien ausblenden',
	'lineChartProp_hideGridLinesDescription': 'Rasterlinien ausblenden',
	'lineChartProp_hideAxisTitleLabelsLabel': 'Achsentitelbeschriftungen ausblenden',
	'lineChartProp_hideAxisTitleLabelsDescription': 'Titel für die Achsen ausblenden.',
	'lineChartProp_maintainAxisScalesLabel': 'Achsenskala beibehalten',
	'lineChartProp_maintainAxisScalesDescription': 'Mindest- und Maximalwerte stets auf den Achsen anzeigen.',
	'lineChartProp_suppressZerosLabel': 'Leere Kategorien ausblenden',
	'lineChartProp_suppressZerosDescription': 'Kategorien ohne zugehörige Werte ausblenden.',
	'packedBubbleChart1CatCaption': 'Kompaktes Blasendiagramm',
	'packedBubbleChart1CatDataSlot_categoriesLabel': 'Kategorien',
	'packedBubbleChart1CatDataSlot_sizeLabel': 'Größe nach',
	'packedBubbleChart1CatProp_colorPaletteLabel': 'Farbpaletten',
	'packedBubbleChart1CatProp_elementColorLabel': 'Blasenfarbe',
	'packedBubbleChart1CatProp_hideLabelLabel': 'Beschriftung ausblenden',
	'packedBubbleChart1CatProp_hideValueLabel': 'Wert ausblenden',
	'packedBubbleChart1CatProp_maintainAxisScalesLabel': 'Achsenskala beibehalten',
	'packedBubbleChart1CatProp_maintainAxisScalesDescription': 'Mindest- und Maximalwerte stets auf den Achsen anzeigen.',
	'packedBubbleChart1CatProp_suppressZerosLabel': 'Leere Kategorien ausblenden',
	'packedBubbleChart1CatProp_suppressZerosDescription': 'Kategorien ohne zugehörige Werte ausblenden.',
	'heatChartCaption': 'Heat-Map',
	'heatChartDataSlot_valuesLabel': 'Heat-Map nach',
	'heatChartDataSlot_xAxisLabel': 'Horizontale Achse',
	'heatChartDataSlot_yAxisLabel': 'Vertikale Achse',
	'heatChartProp_colorPaletteLabel': 'Farbpaletten',
	'heatChartProp_heatScalePaletteLabel': 'Farbreihenfolge',
	'heatChartProp_hideAxisTitleLabelsLabel': 'Achsentitelbeschriftungen ausblenden',
	'heatChartProp_hideAxisTitleLabelsDescription': 'Titel für die Achsen ausblenden.',
	'heatChartProp_maintainAxisScalesLabel': 'Achsenskala beibehalten',
	'heatChartProp_maintainAxisScalesDescription': 'Mindest- und Maximalwerte stets auf den Achsen anzeigen.',
	'heatChartProp_suppressZerosLabel': 'Leere Kategorien ausblenden',
	'heatChartProp_suppressZerosDescription': 'Kategorien ohne zugehörige Werte ausblenden.',
	'heatChartProp_hideLegendLabel': 'Legende ausblenden',
	'heatChartProp_hideLegendDescription': 'Legende ausblenden.',
	'heatChartProp_legendPositionLabel': 'Position der Legende',
	'pieChartCaption': 'Kreisdiagramm',
	'pieChartDataSlot_categoriesLabel': 'Kategorien',
	'pieChartDataSlot_valuesLabel': 'Wert',
	'pieChartProp_colorPaletteLabel': 'Farbpaletten',
	'pieChartProp_hideRadialValueLabel': 'Wert ausblenden',
	'pieChartProp_pieAsDonutLabel': 'Als Ringdiagramm anzeigen',
	'pieChartProp_pieAsDonutDescription': 'Als Ringdiagramm anzeigen',
	'pieChartProp_suppressZerosLabel': 'Leere Kategorien ausblenden',
	'pieChartProp_suppressZerosDescription': 'Kategorien ohne zugehörige Werte ausblenden.',
	'pieChartProp_hideLegendLabel': 'Legende ausblenden',
	'pieChartProp_hideLegendDescription': 'Legende ausblenden.',
	'pieChartProp_legendPositionLabel': 'Position der Legende',
	'map1measureCaption': 'Landkarte',
	'map1measureDataSlot_categoriesLabel': 'Regionen',
	'map1measureDataSlot_valuesLabel': 'Heat-Map - Regionen',
	'map1measureProp_colorPaletteLabel': 'Farbpaletten',
	'map1measureProp_heatScalePaletteLabel': 'Farbreihenfolge',
	'map1measureProp_maintainAxisScalesLabel': 'Achsenskala beibehalten',
	'map1measureProp_maintainAxisScalesDescription': 'Mindest- und Maximalwerte stets auf den Achsen anzeigen.',
	'map1measureProp_suppressZerosLabel': 'Leere Kategorien ausblenden',
	'map1measureProp_suppressZerosDescription': 'Kategorien ohne zugehörige Werte ausblenden.',
	'map1measureProp_hideLegendLabel': 'Legende ausblenden',
	'map1measureProp_hideLegendDescription': 'Legende ausblenden.',
	'map1measureProp_legendPositionLabel': 'Position der Legende',
	'radialChartCaption': 'Radialdiagramm',
	'radialChartDataSlot_categoriesLabel': 'Kategorien',
	'radialChartDataSlot_valuesLabel': 'Wert',
	'radialChartProp_colorPaletteLabel': 'Farbpaletten',
	'radialChartProp_elementColorLabel': 'Farbe für radiale Säule',
	'radialChartProp_hideRadialTitleLabel': 'Titel ausblenden',
	'radialChartProp_hideRadialValueLabel': 'Wert ausblenden',
	'radialChartProp_maintainAxisScalesLabel': 'Achsenskala beibehalten',
	'radialChartProp_maintainAxisScalesDescription': 'Mindest- und Maximalwerte stets auf den Achsen anzeigen.',
	'radialChartProp_suppressZerosLabel': 'Leere Kategorien ausblenden',
	'radialChartProp_suppressZerosDescription': 'Kategorien ohne zugehörige Werte ausblenden.',
	'pointChart1catCaption': 'Punktdiagramm',
	'pointChart1catDataSlot_valuesLabel': 'Wert',
	'pointChart1catDataSlot_categoriesLabel': 'Achsenbeschriftung',
	'pointChart1catProp_colorPaletteLabel': 'Farbpaletten',
	'pointChart1catProp_elementColorLabel': 'Farbe für Formen',
	'pointChart1catProp_symbolShapeLabel': 'Symbolform',
	'pointChart1catProp_symbolFillLabel': 'Form füllen',
	'pointChart1catProp_symbolFillDescription': 'Füllfarbe für die Symbole anzeigen.',
	'pointChart1catProp_hideGridLinesLabel': 'Rasterlinien ausblenden',
	'pointChart1catProp_hideGridLinesDescription': 'Rasterlinien ausblenden',
	'pointChart1catProp_hideAxisTitleLabelsLabel': 'Achsentitelbeschriftungen ausblenden',
	'pointChart1catProp_hideAxisTitleLabelsDescription': 'Titel für die Achsen ausblenden.',
	'pointChart1catProp_maintainAxisScalesLabel': 'Achsenskala beibehalten',
	'pointChart1catProp_maintainAxisScalesDescription': 'Mindest- und Maximalwerte stets auf den Achsen anzeigen.',
	'pointChart1catProp_suppressZerosLabel': 'Leere Kategorien ausblenden',
	'pointChart1catProp_suppressZerosDescription': 'Kategorien ohne zugehörige Werte ausblenden.',
	'scatterPlotChartNoCatCaption': 'Streudiagramm',
	'scatterPlotChartNoCatDataSlot_xAxisLabel': 'Horizontale Achse',
	'scatterPlotChartNoCatDataSlot_yAxisLabel': 'Vertikale Achse',
	'scatterPlotChartNoCatProp_colorPaletteLabel': 'Farbpaletten',
	'scatterPlotChartNoCatProp_elementColorLabel': 'Elementfarbe',
	'scatterPlotChartNoCatProp_symbolShapeLabel': 'Symbolform',
	'scatterPlotChartNoCatProp_symbolFillLabel': 'Form füllen',
	'scatterPlotChartNoCatProp_symbolFillDescription': 'Füllfarbe für die Symbole anzeigen.',
	'scatterPlotChartNoCatProp_hideGridLinesLabel': 'Rasterlinien ausblenden',
	'scatterPlotChartNoCatProp_hideGridLinesDescription': 'Rasterlinien ausblenden',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel': 'Achsentitelbeschriftungen ausblenden',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription': 'Titel für die Achsen ausblenden.',
	'radialBarChartCaption': 'Radiales Balkendiagramm',
	'radialBarChartDataSlot_categoriesLabel': 'Kategorien',
	'radialBarChartDataSlot_valuesLabel': 'Wert',
	'radialBarChartProp_colorPaletteLabel': 'Farbpaletten',
	'radialBarChartProp_elementColorLabel': 'Farbe für radiale Säule',
	'radialBarChartProp_hideRadialTitleLabel': 'Titel ausblenden',
	'radialBarChartProp_maintainAxisScalesLabel': 'Achsenskala beibehalten',
	'radialBarChartProp_maintainAxisScalesDescription': 'Mindest- und Maximalwerte stets auf den Achsen anzeigen.',
	'radialBarChartProp_suppressZerosLabel': 'Leere Kategorien ausblenden',
	'radialBarChartProp_suppressZerosDescription': 'Kategorien ohne zugehörige Werte ausblenden.',
	'lineColumnComboChartCaption': 'Linien- und Säulendiagramm',
	'lineColumnComboChartDataSlot_categoryLabel': 'Achsenbeschriftung',
	'lineColumnComboChartDataSlot_lineValueLabel': 'Linienwert',
	'lineColumnComboChartDataSlot_columnValueLabel': 'Säulenwert',
	'lineColumnComboChartProp_colorPaletteLabel': 'Farbpaletten',
	'lineColumnComboChartProp_elementColorLabel': 'Säulenfarbe',
	'lineColumnComboChartProp_lineColorLabel': 'Linien- und Symbolfarbe',
	'lineColumnComboChartProp_symbolShapeLabel': 'Symbolform',
	'lineColumnComboChartProp_hideSymbolsLabel': 'Symbole ausblenden',
	'lineColumnComboChartProp_hideSymbolsDescription': 'Symbole ausblenden',
	'lineColumnComboChartProp_hideDataLinesLabel': 'Linie(n) ausblenden',
	'lineColumnComboChartProp_hideDataLinesDescription': 'Linie(n) ausblenden',
	'lineColumnComboChartProp_interpolationLabel': 'Geglättete Linien',
	'lineColumnComboChartProp_interpolationDescription': 'Verbindungslinien zwischen den Datenpunkten sind gebogen.',
	'lineColumnComboChartProp_hideGridLinesLabel': 'Rasterlinien ausblenden',
	'lineColumnComboChartProp_hideGridLinesDescription': 'Rasterlinien ausblenden',
	'lineColumnComboChartProp_hideAxisTitleLabelsLabel': 'Achsentitelbeschriftungen ausblenden',
	'lineColumnComboChartProp_hideAxisTitleLabelsDescription': 'Titel für die Achsen ausblenden.',
	'lineColumnComboChartProp_maintainAxisScalesLabel': 'Achsenskala beibehalten',
	'lineColumnComboChartProp_maintainAxisScalesDescription': 'Mindest- und Maximalwerte stets auf den Achsen anzeigen.',
	'lineColumnComboChartProp_suppressZerosLabel': 'Leere Kategorien ausblenden',
	'lineColumnComboChartProp_suppressZerosDescription': 'Kategorien ohne zugehörige Werte ausblenden.',
	'lineColumnComboChartProp_hideLegendLabel': 'Legende ausblenden',
	'lineColumnComboChartProp_hideLegendDescription': 'Legende ausblenden.',
	'lineColumnComboChartProp_legendPositionLabel': 'Position der Legende',
	'summaryCaption': 'Zusammenfassung',
	'areaName': 'Flächendiagramm',
	'areaDescription': 'Flächendiagramm',
	'areaDataSlot_colorLabel': 'Farbe nach',
	'areaDataSlot_valuesLabel': 'Wert',
	'areaDataSlot_categoriesLabel': 'Achsenbeschriftung',
	'bubbleName': 'Blasendiagramm',
	'bubbleDescription': 'Blasendiagramm',
	'bubbleDataSlot_yAxisLabel': 'Vertikale Achse',
	'bubbleDataSlot_xAxisLabel': 'Horizontale Achse',
	'bubbleDataSlot_sizeLabel': 'Größe nach',
	'bubbleDataSlot_colorLabel': 'Farbe nach',
	'clusterBarName': 'Balkendiagramm',
	'clusterBarDescription': 'Balkendiagramm',
	'clusterBarDataSlot_colorLabel': 'Farbe nach',
	'clusterBarDataSlot_valuesLabel': 'Wert',
	'clusterBarDataSlot_categoriesLabel': 'Achsenbeschriftung',
	'clusterBarDataSlot_valuesRepeatingLabel': 'Wert',
	'clusterColumnName': 'Säulendiagramm',
	'clusterColumnDescription': 'Säulendiagramm',
	'clusterColumnDataSlot_colorLabel': 'Farbe nach',
	'clusterColumnDataSlot_valuesLabel': 'Wert',
	'clusterColumnDataSlot_categoriesLabel': 'Achsenbeschriftung',
	'clusterColumnDataSlot_valuesRepeatingLabel': 'Wert',
	'clusterLineName': 'Liniendiagramm',
	'clusterLineDescription': 'Liniendiagramm',
	'clusterLineDataSlot_colorLabel': 'Farbe nach',
	'clusterLineDataSlot_valuesLabel': 'Vertikale Achse',
	'clusterLineDataSlot_categoriesLabel': 'Horizontale Achse',
	'clusterLineDataSlot_valuesRepeatingLabel': 'Wert',
	'gridName': 'Raster',
	'gridDescription': 'Raster',
	'gridDataSlot_grid_colsLabel': 'Säulendiagramm',
	'heatName': 'Heat-Map',
	'heatDescription': 'Heat-Map',
	'heatDataSlot_yAxisLabel': 'Vertikale Achse',
	'heatDataSlot_xAxisLabel': 'Horizontale Achse',
	'heatDataSlot_valuesLabel': 'Heat-Map nach',
	'lineColumnComboName': 'Linien- und Säulendiagramm',
	'lineColumnComboDescription': 'Linien- und Säulendiagramm',
	'lineColumnComboDataSlot_lineValueLabel': 'Linienwert',
	'lineColumnComboDataSlot_categoryLabel': 'Achsenbeschriftung',
	'lineColumnComboDataSlot_columnValueLabel': 'Säulenwert',
	'mapName': 'Vorgängerlandkarte',
	'mapDescription': 'Vorgängerlandkarte',
	'mapDataSlot_sizeLabel': 'Punktgröße',
	'mapDataSlot_valuesLabel': 'Heat-Map - Regionen',
	'mapDataSlot_sizeHeatLabel': 'Heat-Map - Punktdiagramm',
	'mapDataSlot_categoriesLabel': 'Regionen',
	'packedBubbleName': 'Kompaktes Blasendiagramm',
	'packedBubbleDescription': 'Kompaktes Blasendiagramm',
	'packedBubbleDataSlot_sizeLabel': 'Größe nach',
	'packedBubbleDataSlot_colorLabel': 'Farbe nach',
	'packedBubbleDataSlot_categoriesLabel': 'Kategorien',
	'pieName': 'Kreisdiagramm',
	'pieDescription': 'Kreisdiagramm',
	'pieDataSlot_valuesLabel': 'Wert',
	'pieDataSlot_categoriesLabel': 'Kategorien',
	'playerName': 'Data Player',
	'playerDescription': 'Data Player',
	'playerDataSlot_categoriesLabel': 'Achsenbeschriftung',
	'pointName': 'Punktdiagramm',
	'pointDescription': 'Punktdiagramm',
	'pointDataSlot_colorLabel': 'Farbe nach',
	'pointDataSlot_valuesLabel': 'Wert',
	'pointDataSlot_categoriesLabel': 'Achsenbeschriftung',
	'radialName': 'Radialdiagramm',
	'radialDescription': 'Radialdiagramm',
	'radialDataSlot_valuesLabel': 'Wert',
	'radialDataSlot_maxSizeLabel': 'Maximalwert',
	'radialDataSlot_categoriesLabel': 'Kategorien',
	'radialBarName': 'Radiales Balkendiagramm',
	'radialBarDescription': 'Radiales Balkendiagramm',
	'radialBarDataSlot_valuesLabel': 'Wert',
	'radialBarDataSlot_categoriesLabel': 'Kategorien',
	'scatterPlotName': 'Streudiagramm',
	'scatterPlotDescription': 'Streudiagramm',
	'scatterPlotDataSlot_yAxisLabel': 'Vertikale Achse',
	'scatterPlotDataSlot_xAxisLabel': 'Horizontale Achse',
	'scatterPlotDataSlot_colorLabel': 'Farbe nach',
	'scatterPlotDataSlot_categoriesLabel': 'Punkte',
	'stackedBarName': 'Gestapeltes Balkendiagramm',
	'stackedBarDescription': 'Gestapeltes Balkendiagramm',
	'stackedBarDataSlot_colorLabel': 'Farbe nach',
	'stackedBarDataSlot_valuesLabel': 'Wert',
	'stackedBarDataSlot_categoriesLabel': 'Achsenbeschriftung',
	'stackedBarDataSlot_valuesRepeatingLabel': 'Wert',
	'stackedColumnName': 'Gestapeltes Säulendiagramm',
	'stackedColumnDescription': 'Gestapeltes Säulendiagramm',
	'stackedColumnDataSlot_colorLabel': 'Farbe nach',
	'stackedColumnDataSlot_valuesLabel': 'Wert',
	'stackedColumnDataSlot_categoriesLabel': 'Achsenbeschriftung',
	'stackedColumnDataSlot_valuesRepeatingLabel': 'Wert',
	'summaryChartName': 'Zusammenfassung',
	'summaryChartDescription': 'Zusammenfassung',
	'summaryChartDataSlot_valuesLabel': 'Wert',
	'treeMapName': 'Treemap',
	'treeMapDescription': 'Treemap',
	'treeMapDataSlot_colorLabel': 'Heat-Map nach',
	'treeMapDataSlot_valuesLabel': 'Größe nach',
	'treeMapDataSlot_categoriesLabel': 'Ebene 1',
	'treeMapDataSlot_level3Label': 'Ebene 3',
	'treeMapDataSlot_level2Label': 'Ebene 2',
	'wordCloudName': 'Wortwolke',
	'wordCloudDescription': 'Wortwolke',
	'wordCloudDataSlot_colorLabel': 'Farbe nach',
	'wordCloudDataSlot_scaleLabel': 'Größe nach',
	'wordCloudDataSlot_wordLabel': 'Wörter',
	'treeMap1Cat1MeasureChartCaption': 'Treemap',
	'treeMap1Cat1MeasureChartDataSlot_categoriesLabel': 'Ebene 1',
	'treeMap1Cat1MeasureChartDataSlot_valuesLabel': 'Größe nach',
	'treeMap1Cat1MeasureChartProp_colorPaletteLabel': 'Farbpaletten',
	'treeMap1Cat2MeasureChartProp_colorPaletteLabel': 'Farbpaletten',
	'treeMap2Cat1MeasureChartProp_colorPaletteLabel': 'Farbpaletten',
	'treeMap2Cat2MeasureChartProp_colorPaletteLabel': 'Farbpaletten',
	'treeMap3Cat1MeasureChartProp_colorPaletteLabel': 'Farbpaletten',
	'treeMap3Cat2MeasureChartProp_colorPaletteLabel': 'Farbpaletten',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel': 'Achsenskala beibehalten',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription': 'Mindest- und Maximalwerte stets auf den Achsen anzeigen.',
	'treeMap1Cat1MeasureChartProp_suppressZerosLabel': 'Leere Kategorien ausblenden',
	'treeMap1Cat1MeasureChartProp_suppressZerosDescription': 'Kategorien ohne zugehörige Werte ausblenden.',
	'treeMap1Cat1MeasureChartProp_hideLegendLabel': 'Legende ausblenden',
	'treeMap1Cat1MeasureChartProp_hideLegendDescription': 'Legende ausblenden.',
	'treeMap1Cat1MeasureChartProp_legendPositionLabel': 'Position der Legende',
	'wordChart1Cat1MeasureCaption': 'Wortwolke',
	'wordChart1Cat1MeasureDataSlot_wordLabel': 'Wörter',
	'wordChart1Cat1MeasureDataSlot_scaleLabel': 'Größe nach',
	'wordChart1Cat1MeasureProp_colorPaletteLabel': 'Farbpaletten',
	'wordChart1Cat1MeasureProp_elementColorLabel': 'Wortfarbe',
	'wordChart1Cat1MeasureProp_maintainAxisScalesLabel': 'Achsenskala beibehalten',
	'wordChart1Cat1MeasureProp_maintainAxisScalesDescription': 'Mindest- und Maximalwerte stets auf den Achsen anzeigen.',
	'wordChart1Cat1MeasureProp_suppressZerosLabel': 'Leere Kategorien ausblenden',
	'wordChart1Cat1MeasureProp_suppressZerosDescription': 'Kategorien ohne zugehörige Werte ausblenden.',
	'missingDataSetData': 'Die Daten für dieses Dataset sind nicht verfügbar. Aktualisieren Sie das Dataset oder wenden Sie sich an den Administrator, um Zugriff auf die Quelle zu erhalten.',
	'hideShowSummaries': 'Zusammenfassungen ausblenden/einblenden',
	'crosstabName': 'Kreuztabelle',
	'value_is_not_available': 'Nicht zutreffend',
	'swapRowsAndColumns': 'Zeilen und Spalten tauschen',
	'NoPinsCollected': 'Keine Visualisierungen mit Pins',
	'pinSearchOld': 'Eigene Pins durchsuchen',
	'pinDeletedToast': 'Pin wurde entfernt',
	'pinAddedToast': 'Pin wurde erfolgreich zu eigenen Pins hinzugefügt',
	'pinRetrieveError': 'Ein oder mehrere Pins können nicht abgerufen werden. Wiederholen Sie den Vorgang zu einem späteren Zeitpunkt.',
	'pinErrorTitle': 'Fehler beim Fixieren',
	'renamePinTooltip': 'Name eingeben ...',
	'renamePinInvalidText': 'Dieses Feld ist erforderlich.',
	'pinRemove': 'Entfernen',
	'deletePin': 'Pin löschen',
	'renamePin': 'Umbenennen',
	'cancelRenamePin': 'Abbrechen',
	'confirmRenamePin': 'Fertig',
	'dataset_time': 'Zeit',
	'dataset_date': 'Datum',
	'dataset_location': 'Position',
	'dataset_number': 'Anzahl',
	'dataset_text': 'Text',
	'widgetConditionalFormatLabel': 'Steuerelemente zum Wechseln bedingter Formate',
	'deletePinConfirmationMessage': 'Soll dieser Pin tatsächlich gelöscht werden? Diese Aktion kann nicht rückgängig gemacht werden.',
	'deletePinConfirm': 'Löschen bestätigen',
	'pinDeleteError': 'Ein oder mehrere Pins können nicht gelöscht werden. Wiederholen Sie den Vorgang zu einem späteren Zeitpunkt.',
	'metadataPickerTitle': 'Dataset erstellen',
	'moreTitle': 'Mehr',
	'remove_slider_handle': 'Ziehpunkt entfernen',
	'missingFiltering': 'Spalte fehlt:',
	'unSupportedPromptType': 'Das Eingabeaufforderungsszenario wird zurzeit nicht unterstützt.',
	'preAggregateLabel': 'Eingabeaufforderungswerte aus der Datenquelle anwenden',
	'postAggregateLabel': 'Eingabeaufforderungswerte im Bericht anwenden',
	'preAggregateText': 'Der Bereich verwendet die Werte in der Datenquelle, nicht die im Dashboard angezeigten Werte.',
	'tabName_general': 'Allgemein', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visDetails': 'Details',
	'tabName_textDetails': 'Textdetails', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_mediaDetails': 'Mediendetails', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_webDetails': 'Webseitendetails', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_imageDetails': 'Bilddetails', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visualization': 'Visualisierung',
	'sectionName_canvas': 'Erstellungsbereich',
	'sectionName_colorsAndThemes_v1': 'Farbe und Motiv',
	'sectionName_colorsAndThemes': 'Motiv & Hintergrund',
	'colorsAndThemes_legacyWarning': 'Das aktuelle Dashboard verwendet ein Motiv aus einem früheren Release. Wenn das Motiv geändert und das Dashboard permanent gespeichert wird, besteht kein Zugriff mehr auf die Paletten des früheren Motivs. ',
	'sectionName_details': 'Details',
	'sectionName_positionAndStyle': 'Position & Stil',
	'sectionName_appearance': 'Darstellung', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_advanced': 'Erweitert',
	'sectionName_layout': 'Layout', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_tabs': 'Registerkartenbeschriftungen',
	'sectionName_tabTitle': 'Beschriftung',
	'sectionName_tabBackground': 'Hintergrund',
	'addDataSourceDialogTitle': 'Datenquelle hinzufügen',
	'addDataSourceDialogButtonLabel': 'Hinzufügen',
	'shapesDoubleChevron': 'Doppelter Winkel',
	'widgetsPanelTitle': 'Widgets',
	'widgetsPanelBasicsTab': 'Basiskomponenten',
	'widgetsPanelImageLibraryTab': 'Bilder',
	'widgetsPanelSectionStandard': 'Standard',
	'widgetsPanelSectionAdvanced': 'Erweitert',
	'widgetsPanelSectionShapes': 'Formen',
	'customWidgetsTitle': 'Benutzerdefinierte Widgets',
	'filterItemCanvasMove': 'Zum Erstellungsbereich hinzufügen',
	'filterOverflowMenu_Global': 'Alle Registerkarten - Überlaufmenü',
	'filterOverflowMenu_Tab': 'Diese Registerkarte - Überlaufmenü',
	'filterOverflowMenu_Item': 'Filter - Überlaufmenü',
	'filterOverflowMenu_Single': 'Überlaufmenü',
	'filterItemEdit': 'Filterwerte bearbeiten',
	'filterDeleteAllItems': 'Alle Filter löschen',
	'filterClearAllItems': 'Alle Filter aufheben',
	'filterClearSelection': 'Filter aufheben',
	'filterPlayerMode': 'Player anzeigen',
	'filterStaticMode': 'Liste anzeigen',
	'filterInvertSelection': 'Filterauswahl umkehren',
	'filterIconLabel_Global': 'Alle Registerkarten',
	'filterIconLabel_Single': 'Filter',
	'filterIconLabel_Tab': 'Diese Registerkarte',
	'filterIconTooltip_Global': 'Alle Registerkarten',
	'filterIconTooltip_Tab': 'Diese Registerkarte',
	'filterIconTooltip_Single': 'Filter',
	'filterItemDelete': 'Filter löschen',
	'filterValueSeparator': ',',
	'filterRange': '%{from}-%{to}',
	'filterInvertRange': 'Alles außer: %{from} - %{to}',
	'filterExcept': 'Außer %{values}',
	'filterAll': 'Alle',
	'filterBlank': '(leer)',
	'filterDisableRangeInvert': 'Nicht verfügbar, wenn für diese Spalte der Filter "Alle Registerkarten" aktiviert ist.',
	'filterDisableHierarchyInvert': 'Nicht verfügbar, wenn es sich bei dieser Spalte um einen Hierarchiefilter handelt.',
	'filterSelectedOfTotal': '%{selected} von %{totalMembers}',
	'filter_date_before': 'Vor %{to}',
	'filter_date_before_except': 'Nicht vor %{to}',
	'filter_date_after': 'Nach %{from}',
	'filter_date_after_except': 'Nicht nach %{from}',
	'filter_date_between': 'Zwischen %{from} und %{to}',
	'filter_date_between_except': 'Nicht zwischen %{from} und %{to}',
	'filter_drag_and_drop_all_tabs': 'Daten hierher ziehen und ablegen, um alle Registerkarten zu filtern.',
	'filter_drag_and_drop_current_tab': 'Daten hierher ziehen und ablegen, um diese Registerkarte zu filtern.',
	'filter_drag_and_drop_single_dock': 'Daten zum Filtern hierher ziehen und ablegen.',
	'errMsgFilterItemGenericTitle': 'Laden der Filterwerte nicht möglich',
	'widgetChromeRotate': 'Drehen',
	'toolbarRegionLabel': 'Symbolleiste',
	'toolbarActionDelete': 'Löschen',
	'toolbarActionGroup': 'Gruppe',
	'toolbarActionUngroup': 'Gruppierung aufheben',
	'toolbarActionOrderToFront': 'Nach vorne',
	'toolbarActionOrderToBack': 'Nach hinten',
	'toolbarActionEditTitle': 'Titel bearbeiten',
	'toolbarActionWrapTitle': 'Titel umbrechen',
	'toolbarActionPin': 'Sammeln',
	'toolbarActionPinOld': 'Pin',
	'toolbarActionAlign': 'Ausrichten',
	'alignWidgetLeft': 'Links',
	'alignWidgetCenter': 'Zentriert',
	'alignWidgetRight': 'Rechts',
	'alignWidgetTop': 'Oben',
	'alignWidgetMiddle': 'Mitte',
	'alignWidgetBottom': 'Unten',
	'distributeWidgetsVertical': 'Vertikal verteilen',
	'distributeWidgetsHoriz': 'Horizontal verteilen',
	'toolbarChangeVisualization': 'Visualisierung ändern',
	'multipurposeHeader': 'Widgettyp auswählen',
	'multipurposePlaceholderText': 'Als ersten Schritt eines der Widgets auswählen. ',
	'live_label': 'Diagramm',
	'filter_label': 'Filtern',
	'one_named_live': 'Diagramm - %{name}',
	'one_named_live_numbered': 'Diagramm - %{name} (%{number})',
	'one_unknown_live': 'Diagramm',
	'one_unknown_live_numbered': 'Diagramm (%{number})',
	'few_live': 'Gruppe mit %{count} Diagrammen',
	'many_live': 'Gruppe mit %{count} Diagrammen',
	'one_custom': 'Benutzerdefiniertes Widget',
	'one_custom_named': '%{name}',
	'one_custom_named_numbered': '%{name} (%{number})',
	'one_named_filter': 'Filter - %{name}',
	'one_named_filter_numbered': 'Filter - %{name} (%{number})',
	'one_unknown_filter': 'Filtern',
	'one_unknown_filter_numbered': 'Filter (%{number})',
	'few_filter': 'Gruppe mit %{count} Filtern',
	'many_filter': 'Gruppe mit %{count} Filtern',
	'LIVE_bar_has_mapping': 'Balkendiagramm mit %{values}',
	'LIVE_bar_has_mapping_numbered': 'Balkendiagramm mit %{values} (%{number})',
	'LIVE_bar_opt_mapping': 'Balkendiagramm mit %{categories} und %{values}',
	'LIVE_bar_opt_mapping_numbered': 'Balkendiagramm mit %{categories} und %{values} (%{number})',
	'LIVE_bar_no_mapping': 'Leeres Balkendiagramm',
	'LIVE_bar_no_mapping_numbered': 'Leeres Balkendiagramm (%{number})',
	'LIVE_bar_named': 'Balkendiagramm - %{name}',
	'LIVE_bar_named_numbered': 'Balkendiagramm - %{name} (%{number})',
	'LIVE_stacked_bar_has_mapping': 'Gestapeltes Balkendiagramm mit %{values}',
	'LIVE_stacked_bar_has_mapping_numbered': 'Gestapeltes Balkendiagramm mit %{values} (%{number})',
	'LIVE_stacked_bar_opt_mapping': 'Gestapeltes Balkendiagramm mit %{categories} und %{values}',
	'LIVE_stacked_bar_opt_mapping_numbered': 'Gestapeltes Balkendiagramm mit %{categories} und %{values} (%{number})',
	'LIVE_stacked_bar_no_mapping': 'Leeres gestapeltes Balkendiagramm',
	'LIVE_stacked_bar_no_mapping_numbered': 'Leeres gestapeltes Balkendiagramm (%{number})',
	'LIVE_stacked_bar_named': 'Gestapeltes Balkendiagramm - %{name}',
	'LIVE_stacked_bar_named_numbered': 'Gestapeltes Balkendiagramm - %{name} (%{number})',
	'LIVE_bubble_has_mapping': 'Blasendiagramm mit %{categories}, %{x} und %{y}',
	'LIVE_bubble_has_mapping_numbered': 'Blasendiagramm mit %{categories}, %{x} und %{y} (%{number})',
	'LIVE_bubble_no_mapping': 'Leeres Blasendiagramm',
	'LIVE_bubble_no_mapping_numbered': 'Leeres Blasendiagramm (%{number})',
	'LIVE_bubble_named': 'Leeres Blasendiagramm - %{name}',
	'LIVE_bubble_named_numbered': 'Leeres Blasendiagramm - %{name} (%{number})',
	'LIVE_composite_has_mapping': 'Kombinationsdiagramm mit %{categories}, %{columnValue} und %{lineValue}',
	'LIVE_composite_has_mapping_numbered': 'Kombinationsdiagramm mit %{categories}, %{columnValue} und %{lineValue} (%{number})',
	'LIVE_composite_no_mapping': 'Leeres Kombinationsdiagramm',
	'LIVE_composite_no_mapping_numbered': 'Leeres Kombinationsdiagramm (%{number})',
	'LIVE_composite_named': 'Kombinationsdiagramm - %{name}',
	'LIVE_composite_named_numbered': 'Kombinationsdiagramm - %{name} (%{number})',
	'LIVE_decision_tree_has_mapping': 'Entscheidungsstruktur mit %{values}',
	'LIVE_decision_tree_has_mapping_numbered': 'Entscheidungsstruktur mit %{values} (%{number})',
	'LIVE_decision_tree_no_mapping': 'Leere Entscheidungsstruktur',
	'LIVE_decision_tree_no_mapping_numbered': 'Leere Entscheidungsstruktur (%{number})',
	'LIVE_decision_tree_named': 'Entscheidungsstruktur - %{name}',
	'LIVE_decision_tree_named_numbered': 'Entscheidungsstruktur - %{name} (%{number})',
	'LIVE_packed_bubble_has_mapping': 'Kompaktes Blasendiagramm mit %{categories}',
	'LIVE_packed_bubble_has_mapping_numbered': 'Kompaktes Blasendiagramm mit %{categories} (%{number})',
	'LIVE_packed_bubble_no_mapping': 'Leeres kompaktes Blasendiagramm',
	'LIVE_packed_bubble_no_mapping_numbered': 'Leeres kompaktes Blasendiagramm (%{number})',
	'LIVE_packed_bubble_named': 'Kompaktes Blasendiagramm - %{name}',
	'LIVE_packed_bubble_named_numbered': 'Kompaktes Blasendiagramm - %{name} (%{number})',
	'LIVE_pie_has_mapping': 'Kreisdiagramm mit %{categories} und %{values}',
	'LIVE_pie_has_mapping_numbered': 'Kreisdiagramm mit %{categories} und %{values} (%{number})',
	'LIVE_pie_no_mapping': 'Leeres Kreisdiagramm',
	'LIVE_pie_no_mapping_numbered': 'Leeres Kreisdiagramm (%{number})',
	'LIVE_pie_named': 'Kreisdiagramm - %{name}',
	'LIVE_pie_named_numbered': 'Kreisdiagramm - %{name} (%{number})',
	'LIVE_pie_as_donut_has_mapping': 'Ringdiagramm mit %{categories} und %{values}',
	'LIVE_pie_as_donut_has_mapping_numbered': 'Ringdiagramm mit %{categories} und %{values} (%{number})',
	'LIVE_pie_as_donut_no_mapping': 'Leeres Ringdiagramm',
	'LIVE_pie_as_donut_no_mapping_numbered': 'Leeres Ringdiagramm (%{number})',
	'LIVE_pie_as_donut_named': 'Ringdiagramm - %{name}',
	'LIVE_pie_as_donut_named_numbered': 'Ringdiagramm - %{name} (%{number})',
	'LIVE_line_has_mapping': 'Liniendiagramm mit %{categories} und %{values}',
	'LIVE_line_has_mapping_numbered': 'Liniendiagramm mit %{categories} und %{values} (%{number})',
	'LIVE_line_no_mapping': 'Leeres Liniendiagramm',
	'LIVE_line_no_mapping_numbered': 'Leeres Liniendiagramm (%{number})',
	'LIVE_line_named': 'Liniendiagramm - %{name}',
	'LIVE_line_named_numbered': 'Liniendiagramm - %{name} (%{number})',
	'LIVE_area_has_mapping': 'Flächendiagramm mit %{categories} und %{values}',
	'LIVE_area_has_mapping_numbered': 'Flächendiagramm mit %{categories} und %{values} (%{number})',
	'LIVE_area_no_mapping': 'Leeres Flächendiagramm',
	'LIVE_area_no_mapping_numbered': 'Leeres Flächendiagramm (%{number})',
	'LIVE_area_named': 'Flächendiagramm - %{name}',
	'LIVE_area_named_numbered': 'Flächendiagramm - %{name} (%{number})',
	'LIVE_area_as_stacked_percent_has_mapping': 'Gestapeltes Flächendiagramm mit %{categories} und %{values} (mit Prozentsätzen)',
	'LIVE_area_as_stacked_percent_has_mapping_numbered': 'Gestapeltes Flächendiagramm mit %{categories} und %{values} (%{number}) (mit Prozentsätzen)',
	'LIVE_area_as_stacked_percent_no_mapping': 'Leeres gestapeltes Flächendiagramm (mit Prozentsätzen)',
	'LIVE_area_as_stacked_percent_no_mapping_numbered': 'Leeres gestapeltes Flächendiagramm (%{number}) (mit Prozentsätzen)',
	'LIVE_area_as_stacked_percent_named': 'Gestapeltes Flächendiagramm - %{name} (mit Prozentsätzen)',
	'LIVE_area_as_stacked_percent_named_numbered': 'Gestapeltes Flächendiagramm - %{name} (%{number}) (mit Prozentsätzen)',
	'LIVE_heatmap_has_mapping': 'Heat-Map mit %{color}',
	'LIVE_heatmap_has_mapping_numbered': 'Heat-Map mit %{color} (%{number})',
	'LIVE_heatmap_no_mapping': 'Leere Heat-Map',
	'LIVE_heatmap_no_mapping_numbered': 'Leere Heat-Map (%{number})',
	'LIVE_heatmap_named': 'Heat-Map - %{name}',
	'LIVE_heatmap_named_numbered': 'Heat-Map - %{name} (%{number})',
	'LIVE_network_opt_mapping': 'Netzdiagramm mit %{categories}, %{series} und %{values}',
	'LIVE_network_opt_mapping_numbered': 'Netzdiagramm mit %{categories}, %{series} und %{values} (%{number})',
	'LIVE_network_has_mapping': 'Netzdiagramm mit %{categories} und %{series}',
	'LIVE_network_has_mapping_numbered': 'Netzdiagramm mit %{categories} und %{series} (%{number})',
	'LIVE_network_no_mapping': 'Leeres Netzdiagramm',
	'LIVE_network_no_mapping_numbered': 'Leeres Netzdiagramm (%{number})',
	'LIVE_network_named': 'Netzdiagramm - %{name}',
	'LIVE_network_named_numbered': 'Netzdiagramm - %{name} (%{number})',
	'LIVE_radial_bar_opt_mapping': 'Radiales Balkendiagramm mit %{categories} und %{values}',
	'LIVE_radial_bar_opt_mapping_numbered': 'Radiales Balkendiagramm mit %{categories} und %{values} (%{number})',
	'LIVE_radial_bar_has_mapping': 'Radiales Balkendiagramm mit %{values}',
	'LIVE_radial_bar_has_mapping_numbered': 'Radiales Balkendiagramm mit %{values} (%{number})',
	'LIVE_radial_bar_no_mapping': 'Leeres radiales Balkendiagramm',
	'LIVE_radial_bar_no_mapping_numbered': 'Leeres radiales Balkendiagramm (%{number})',
	'LIVE_radial_bar_named': 'Radiales Balkendiagramm - %{name}',
	'LIVE_radial_bar_named_numbered': 'Radiales Balkendiagramm - %{name} (%{number})',
	'LIVE_spiral_has_mapping': 'Spiraldiagramm mit %{values}',
	'LIVE_spiral_has_mapping_numbered': 'Spiraldiagramm mit %{values} (%{number})',
	'LIVE_spiral_no_mapping': 'Leeres Spiraldiagramm',
	'LIVE_spiral_no_mapping_numbered': 'Leeres Spiraldiagramm (%{number})',
	'LIVE_spiral_named': 'Spiraldiagramm - %{name}',
	'LIVE_spiral_named_numbered': 'Spiraldiagramm - %{name} (%{number})',
	'LIVE_treemap_has_mapping': 'Treemap mit %{categories} und %{size}',
	'LIVE_treemap_has_mapping_numbered': 'Treemap mit %{categories} und %{size} (%{number})',
	'LIVE_treemap_no_mapping': 'Leere Treemap',
	'LIVE_treemap_no_mapping_numbered': 'Leere Treemap (%{number})',
	'LIVE_treemap_named': 'Treemap - %{name}',
	'LIVE_treemap_named_numbered': 'Treemap - %{name} (%{number})',
	'LIVE_wordcloud_has_mapping': 'Wortwolke mit %{categories}',
	'LIVE_wordcloud_has_mapping_numbered': 'Wortwolke mit %{categories} (%{number})',
	'LIVE_wordcloud_no_mapping': 'Leere Wortwolke',
	'LIVE_wordcloud_no_mapping_numbered': 'Leere Wortwolke (%{number})',
	'LIVE_wordcloud_named': 'Wortwolke - %{name}',
	'LIVE_wordcloud_named_numbered': 'Wortwolke - %{name} (%{number})',
	'LIVE_data_player_has_mapping': 'Data Player mit %{category}',
	'LIVE_data_player_has_mapping_numbered': 'Data Player mit %{category} (%{number})',
	'LIVE_data_player_no_mapping': 'Leerer Data Player',
	'LIVE_data_player_no_mapping_numbered': 'Leerer Data Player (%{number})',
	'LIVE_data_player_named': 'Data Player - %{name}',
	'LIVE_data_player_named_numbered': 'Data Player - %{name} (%{number})',
	'LIVE_map_has_mapping': 'Karte mit %{locations}',
	'LIVE_map_has_mapping_numbered': 'Karte mit %{locations} (%{number})',
	'LIVE_map_no_mapping': 'Leere Karte',
	'LIVE_map_no_mapping_numbered': 'Leere Karte (%{number})',
	'LIVE_map_named': 'Karte - %{name}',
	'LIVE_map_named_numbered': 'Karte - %{name} (%{number})',
	'LIVE_point_has_mapping': 'Punktdiagramm mit %{categories} und %{values}',
	'LIVE_point_has_mapping_numbered': 'Punktdiagramm mit %{categories} und %{values} (%{number})',
	'LIVE_point_no_mapping': 'Leeres Punktdiagramm',
	'LIVE_point_no_mapping_numbered': 'Leeres Punktdiagramm (%{number})',
	'LIVE_point_named': 'Punktdiagramm - %{name}',
	'LIVE_point_named_numbered': 'Punktdiagramm - %{name} (%{number})',
	'LIVE_column_has_mapping': 'Säulendiagramm mit %{values}',
	'LIVE_column_has_mapping_numbered': 'Säulendiagramm mit %{values} (%{number})',
	'LIVE_column_opt_mapping': 'Säulendiagramm mit %{categories} und %{values}',
	'LIVE_column_opt_mapping_numbered': 'Säulendiagramm mit %{categories} und %{values} (%{number})',
	'LIVE_column_no_mapping': 'Leeres Säulendiagramm',
	'LIVE_column_no_mapping_numbered': 'Leeres Säulendiagramm (%{number})',
	'LIVE_column_named': 'Säulendiagramm - %{name}',
	'LIVE_column_named_numbered': 'Säulendiagramm - %{name} (%{number})',
	'LIVE_stacked_column_has_mapping': 'Gestapeltes Säulendiagramm mit %{values}',
	'LIVE_stacked_column_has_mapping_numbered': 'Gestapeltes Säulendiagramm mit %{values} (%{number})',
	'LIVE_stacked_column_opt_mapping': 'Gestapeltes Säulendiagramm mit %{categories} und %{values}',
	'LIVE_stacked_column_opt_mapping_numbered': 'Gestapeltes Säulendiagramm mit %{categories} und %{values} (%{number})',
	'LIVE_stacked_column_no_mapping': 'Leeres gestapeltes Säulendiagramm',
	'LIVE_stacked_column_no_mapping_numbered': 'Leeres gestapeltes Säulendiagramm (%{number})',
	'LIVE_stacked_column_named': 'Gestapeltes Säulendiagramm - %{name}',
	'LIVE_stacked_column_named_numbered': 'Gestapeltes Säulendiagramm - %{name} (%{number})',
	'LIVE_scatter_opt_mapping': 'Streudiagramm mit %{categories}, %{x} und %{y}',
	'LIVE_scatter_opt_mapping_numbered': 'Streudiagramm mit %{categories}, %{x} und %{y} (%{number})',
	'LIVE_scatter_has_mapping': 'Streudiagramm mit %{x} verglichen mit %{y}',
	'LIVE_scatter_has_mapping_numbered': 'Streudiagramm mit %{x} verglichen mit %{y} (%{number})',
	'LIVE_scatter_no_mapping': 'Leeres Streudiagramm',
	'LIVE_scatter_no_mapping_numbered': 'Leeres Streudiagramm (%{number})',
	'LIVE_scatter_named': 'Streudiagramm - %{name}',
	'LIVE_scatter_named_numbered': 'Streudiagramm - %{name} (%{number})',
	'LIVE_waterfall_has_mapping': 'Wasserfalldiagramm mit %{values}',
	'LIVE_waterfall_has_mapping_numbered': 'Wasserfalldiagramm mit %{values} (%{number})',
	'LIVE_waterfall_no_mapping': 'Leeres Wasserfalldiagramm',
	'LIVE_waterfall_no_mapping_numbered': 'Leeres Wasserfalldiagramm (%{number})',
	'LIVE_waterfall_named': 'Wasserfalldiagramm - %{name}',
	'LIVE_waterfall_named_numbered': 'Wasserfalldiagramm - %{name} (%{number})',
	'LIVE_empty_visualization_hint_title': 'Visualisierung erstellen',
	'LIVE_empty_visualization_hint_description': 'Spalten hierher oder in die Felder auf der linken Seite ziehen und ablegen.',
	'LIVE_slots_required_field_description': '%{asterisk} Kennzeichnet ein erforderliches Feld',
	'LIVE_slots_drag_and_drop_description': 'Daten in die Felder oben ziehen und ablegen, um die Visualisierung zu erstellen und zu filtern.',
	'requiredField': 'Erforderliches Feld',
	'fullScreenEnter': 'Gesamtanzeigemodus aktivieren',
	'fullScreenClose': 'Gesamtanzeigemodus beenden',
	'noExtraText_multipurpose': 'Platzhalter für verschiedene Zwecke',
	'noExtraText_multipurpose_numbered': 'Platzhalter für verschiedene Zwecke (%{number})',
	'one_placeholder_vis': 'Platzhalter für Visualisierung',
	'one_placeholder_vis_numbered': 'Platzhalter für Visualisierung (%{number})',
	'one_placeholder_text': 'Platzhalter für Text',
	'one_placeholder_text_numbered': 'Platzhalter für Text (%{number})',
	'few_placeholder_text': 'Gruppe mit %{count} Textplatzhaltern',
	'many_placeholder_text': 'Gruppe mit %{count} Textplatzhaltern',
	'filter_includesAll': 'Alles einbeziehen',
	'timeline_filter_moved_to': 'Zeitachsenfilter %{id} nach %{time} verschoben',
	'timelineSettingsButton': 'Wiedergabeoptionen',
	'autoPlay': 'Alle Szenen wiedergeben',
	'loop': 'Wiederholte Wiedergabe',
	'noSceneTransitionLabel': 'Ohne',
	'sceneTransitionPropertyLabel': 'Szenenübergang',
	'animatedPathSceneTransitionLabel': 'Animierter Pfad',
	'sweepSceneTransitionLabel': 'Schneller Übergang',
	'propAniAnimation': 'Animation',
	'propAniTypeEntrance': 'Eingangsanimation',
	'propAniDirectionIn': 'Eingangsrichtung',
	'propAniTypeExit': 'Ausgangsanimation',
	'propAniDirectionOut': 'Ausgangsrichtung',
	'propAniDirection': 'Richtung',
	'timelineAnimationProperties': 'Animationseigenschaften öffnen',
	'editStoryCoachMarkTitle': 'Story bearbeiten',
	'editStoryCoachMarkContents': 'Klicken Sie zum Bearbeiten dieser Story auf das Stiftsymbol.',
	'addDataStoryCoachMarkContents': 'Ziehen Sie Daten aus dem Datenfenster in die Story und legen Sie sie ab.',
	'expandSceneCoachmarkTitle': 'Zeitachse öffnen',
	'expandSceneCoachmarkContents': 'Szene durch Anpassen der Objektsichtbarkeit auf der Basis von Zeit und Dauern animieren.',
	'overviewCoachmarkTitle': 'Übersichtsszenen',
	'overviewCoachmarkContents': 'Mit den Übersichtsszenen am Anfang und Ende der Story können Sie einen allgemeinen Überblick über alle Szenen darstellen. In einer Übersichtsszene können Sie auf eine Szene klicken und diese an die gewünschte Position ziehen, um sie mit einer anderen Szene zu tauschen. Die Übersichtsszenen in den Eigenschaften der Story können ein- oder ausgeblendet werden.',
	'animatedPathCoachmarkTitle': 'Animierter Pfad',
	'animatedPathCoachmarkContents': 'Duplizieren Sie eine Szene mit einem Objekt, um den Übergang eines Objekts von einer Szene in eine andere zu animieren. In der neuen Szene können Sie das duplizierte Objekt verschieben, seine Größe verändern oder es drehen.',
	'tabName_animation': 'Animation',
	'textWidgetIconPlaceholderText': 'Zum Hinzufügen von Text klicken',
	'buildVisHeader': 'Visualisierung erstellen',
	'visIconPlaceholderText': 'Daten ziehen und ablegen, um eine Visualisierung zu erstellen',
	'launchNewExplore': 'Neue Exploration',
	'addTo': 'Hinzufügen zu',
	'addToExisting': 'Hinzufügen zu vorhandenem Element...',
	'exploreData': 'Erkunden',
	'explore_remove_widget_styles': 'Benutzerdefinierte Visualisierungseigenschaften wie Farbeinstellungen werden in der Exploration nicht beibehalten.',
	'editNotebook': 'Widget bearbeiten',
	'thumbnails_error_fetching': 'Fehler beim Abrufen von Piktogrammen',
	'copy': '%{count} Asset(s) kopiert',
	'specConvertErr': 'Beim Einfügen oder Konvertieren der Dashboardspezifikation ist ein Fehler aufgetreten.',
	'specCopyErr': 'Beim Kopieren der Dashboardspezifikation ist ein Fehler aufgetreten.',
	'pasteNotSupportedErr': 'Einfügen aus einer Quelle des Typs %{name} wird nicht unterstützt.',
	'reportParam': 'Bericht',
	'filterWidgetCopyWarn': 'Filter für Visualisierung nicht kopiert, da zum gegenwärtigen Zeitpunkt keine Filter unterstützt werden.',
	'upgradingDashboard': 'Upgrade von "%{name}" für %{version} wird durchgeführt...',
	'upgradeComplete': 'Upgrade abgeschlossen',
	'individualTabProperties': 'Eigenschaften der einzelnen Registerkarten',
	'propMasterTabStylesLabel_v1': 'Globaler Registerkartenstil',
	'propMasterTabStylesLabel': 'Stil für alle Registerkarten',
	'propTabPosition': 'Registerkartenposition',
	'propTabTitle': 'Titel',
	'propTabBackgroundColor': 'Füllfarbe',
	'propTabTextColor': 'Farbe des Titels',
	'propTabSelectedBarColor': 'Farbe des ausgewählten Balkens',
	'propTabRestoreDefaults': 'Standardwerte wiederherstellen',
	'propIndividualTabStylesLabel': 'Stil der einzelnen Registerkarten',
	'propIndividualTabStylesAriaLabel': 'Stileigenschaften der einzelnen Registerkarten öffnen',
	'propTabIconPosition': 'Symbolposition',
	'propLeftTitle': 'Links des Titels',
	'propRightTitle': 'Rechts des Titels',
	'propTopTitle': 'Oberhalb des Titels',
	'propBottomTitle': 'Unterhalb des Titels',
	'propTabIconLabel': 'Visuelles Element',
	'propTabIcon': 'Symbol',
	'propTabIconColor': 'Symbolfarbe',
	'no_icon': 'Leer',
	'announcement': 'Ankündigung',
	'api': 'API',
	'archive': 'Archiv',
	'asset': 'Asset',
	'attachment': 'Anhang',
	'audio': 'Audio',
	'bee': 'Biene',
	'blog': 'Blog',
	'bookmark': 'Lesezeichen',
	'calendar': 'Kalender',
	'camera': 'Kamera',
	'capability': 'Funktion',
	'catalog': 'Katalog',
	'chat_message': 'Chatnachricht',
	'checkout_cart': 'Warenkorb',
	'client': 'Client',
	'clock': 'Uhr',
	'cloud': 'Wolke',
	'code': 'Code',
	'data_quality': 'Datenqualität',
	'folder': 'Ordner',
	'forum': 'Forum',
	'glasses': 'Brille',
	'group': 'Gruppe',
	'hat': 'Hut',
	'headphone': 'Kopfhörer',
	'hills': 'Hügel',
	'home': 'Startseite',
	'idea': 'Idee',
	'image': 'Bild',
	'inventory': 'Bestand',
	'like': 'Like',
	'link': 'Link',
	'location': 'Position',
	'manage': 'Verwalten',
	'pen': 'Stift',
	'mobile_phone': 'Mobiltelefon',
	'music': 'Musik',
	'notifications': 'Benachrichtigungen',
	'paint': 'Zeichnen',
	'payment': 'Bezahlung',
	'password_key': 'Kennwortschlüssel',
	'people': 'Personen',
	'person': 'Person',
	'phone': 'Telefon',
	'pin': 'Pin',
	'print': 'Drucken',
	'recording': 'Aufzeichnung',
	'repository': 'Repository',
	'role': 'Rolle',
	'search': 'Suchen',
	'properties': 'Eigenschaften',
	'speaker': 'Lautsprecher',
	'star': 'Stern',
	'tag': 'Tag',
	'thumbs_up': 'Daumen nach oben',
	'thumbs_down': 'Daumen nach unten',
	'tools': 'Tools',
	'traffic': 'Verkehr',
	'trash': 'Papierkorb',
	'twitter': 'Twitter',
	'unknown': 'Unbekannt',
	'user': 'Benutzer',
	'venn_diagram': 'Venn-Diagramm',
	'video': 'Video',
	'view': 'Ansicht',
	'warning': 'Warnung',
	'watch': 'Überwachung',
	'watson': 'Watson',
	'wikis': 'Wikis',
	'workspace': 'Arbeitsbereich',
	'world': 'Welt',
	'eventGroupButtonLabel': 'Widgetverbindungen anzeigen',
	'dockToolbar': 'Symbolleiste andocken',
	'undockToolbar': 'Symbolleiste abdocken',
	'propShowTitle': 'Titel anzeigen',
	'textAutoFontSize': 'Auto',
	'zoomFitToWidth': 'An Breite anpassen',
	'zoomWholePage': 'An Seite anpassen',
	'defaultZoomValue': 'Standard-Zoomwert',
	'zoomCategoryLabel': 'Seitenzoom (nur absolutes Layout)'
});
